export function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

export function getUniqueList(list) {
    return list.filter(onlyUnique);
}
